import {createContext, useContext, useState, ReactNode} from "react";
import {CreatePostTypeMultiple} from "../types/ComponentProps";

const formInitialState: CreatePostTypeMultiple = {
  message: "",
  imagePost: [],
  pointsGiven: 0,
  coinsGiven: 0,
  recipients: [],
  hashTagIds: [],
};

type PostFormContextType = {
  formPost: CreatePostTypeMultiple;
  setFormPost: React.Dispatch<React.SetStateAction<CreatePostTypeMultiple>>;
  clearImagePost: () => void;
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  postLoading: boolean;
  setPostLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

const PostFormContext = createContext<PostFormContextType | undefined>(
  undefined
);

export const PostFormProvider = ({children}: {children: ReactNode}) => {
  const [formPost, setFormPost] =
    useState<CreatePostTypeMultiple>(formInitialState);
  const [message, setMessage] = useState<string>("");
  const [postLoading, setPostLoading] = useState<boolean>(false);

  const clearImagePost = () => {
    setFormPost((prev) => ({
      ...prev,
      imagePost: [],
    }));
  };

  return (
    <PostFormContext.Provider
      value={{
        formPost,
        setFormPost,
        clearImagePost,
        message,
        setMessage,
        postLoading,
        setPostLoading,
      }}>
      {children}
    </PostFormContext.Provider>
  );
};

export const usePostForm = () => {
  const context = useContext(PostFormContext);
  if (!context) {
    throw new Error("usePostForm must be used within a PostFormProvider");
  }
  return context;
};
